import cookie from "js-cookie";

async function sha256(value) {
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(value));
  return Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, "0")).join("");
}

export async function pushLeadBooked(bookingId) {
  const email = (localStorage.getItem("autobooking_email") || "").trim().toLowerCase();
  const phone = (
    cookie.get("client_phone") ||
    localStorage.getItem("autobooking_phone") ||
    ""
  ).replace(/\D/g, "");
  const data = {
    event: "lead_booked",
    transaction_id: bookingId,
    landing_id: cookie.get("landing_id"),
  };
  if (window.crypto?.subtle) {
    if (email) data.user_email_sha256 = await sha256(email).catch(() => undefined);
    if (phone) data.user_phone_number_sha256 = await sha256(phone).catch(() => undefined);
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}
